var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer__bottom"},[_c('div',{staticClass:"footer__copy"},[_vm._v("© 2026 ФНС ЛАБ СПОРТ")]),_c('div',{staticClass:"footer__button"},[_c('a',{staticClass:"footer__button-link",attrs:{"href":"https://t.me/simpla_help_bot","target":"_blank"}},[_c('i',{staticClass:"fa-brands fa-telegram"}),_vm._v("Поддержка")])])])
}]

export { render, staticRenderFns }